import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';
import { NgOption } from '@ng-select/ng-select';
import Swal from 'sweetalert2';

import { AuthService } from '../services/auth.service';
import { ClienteService } from '../services/cliente.service';
@Component({
	selector: 'app-agencias-edit',
	templateUrl: './agencias-edit.component.html',
	styleUrls: ['./agencias-edit.component.css'],
	animations: [loadingFade]
})

export class AgenciasEditComponent implements OnInit {
	public loading;
	public submitting = false;
	public cliente_id = null;

	public formAgencia: FormGroup;

	public cliente_status;

	constructor(private route: ActivatedRoute,
		private fb: FormBuilder,
		private authSvc: AuthService,
		private clienteSvc: ClienteService,
		private router: Router
	) { }

	ngOnInit() {
		this.criaForm();
		this.loading = true;

		this.route.params.subscribe(params => {
			if (params.id) {
				this.cliente_id = params.id;
				// pega dados a partir do id
				this.clienteSvc.getCliente(params.id).then((data: any) => {
					this.cliente_status = data.cliente_status;
					this.preencheForm({
						cliente_id: data.cliente_id,
						cliente_nome: data.cliente_nome,
						cliente_status: data.cliente_status == 'S' ? true : false
					});
					this.loading = false;
				});
			}
			else {
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formAgencia = this.fb.group({
			cliente_id: null,
			cliente_nome: ['', [Validators.required, Validators.maxLength(100)]],
			cliente_status: null
		});
	}

	preencheForm(dados) {
		this.formAgencia.setValue(dados);
	}

	enviaAgencia() {
		if (this.formAgencia.valid) {
			this.submitting = true;

			let toSend = this.formAgencia.value;
			toSend.cliente_status = toSend.cliente_status ? 'A' : 'I';
			console.log('toSend', toSend)
			if (this.cliente_id === null) { // criar
				this.clienteSvc.criaCliente(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Central criada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/agencias']);
						}
					});
				}).catch(err => {
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.clienteSvc.editaCliente(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Central alterada com sucesso!',
						onClose: () => {
							this.router.navigate(['home/agencias']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formAgencia.controls) {
				let campo = this.formAgencia.get(field);
				campo.markAsTouched();
			}
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	invalid(nome) {
		let input = this.formAgencia.get(nome);
		return input.touched && input.invalid;
	}
}
